/**
 * ==============
 * Tabs Module 
 * =============
 */

const jfTabModule = (function() {
  'use strict';
  
  const config = {

      // Location TabLink Button in Mega Menu
      locationLink : $(".child-nav__list-heading--location"),
      //Filter TabLink Button
      filterLink : $(".filter-category-list__item:not([data-dropdown])"),
      //Cancel Button
      cancelBtn: $("[data-cancelbtn]"),
      //Country Tabs
      countryLink: $(".tab--link"),

  };



   const bindUIAction = function() {
    //Filtering Tab
    $(config.filterLink).jfTabs({
      toggleTabLink: true,
      tabContainer: $('.filter-tab-wrapper')
    });

    //FilterTab close
    $(config.cancelBtn).on('click', function(e) {
      e.preventDefault();
      $('.filter-category-content-panel').removeClass('active');
      $('.filter-category-list__item').removeClass('active');
    })

    //Location Navigation Desktop Tab
    $(config.locationLink).jfTabs({
      firstTabActive: true,
      tabContainer: $('.child-nav__row--location')
    });

    //Country Tabbed Nav
    $(config.countryLink).jfTabs();
   };

   const init = function() {
    bindUIAction();
   };

   return {
     init: init
   }
}());